module.exports = __webpack_public_path__ + "img/hn-power.6efbfb76.svg";